"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadingCategory = void 0;
var ReadingCategory;
(function (ReadingCategory) {
    ReadingCategory["READING_FROM_SUPPLIER"] = "Opname door uw netbeheerder";
    ReadingCategory["READING_FROM_CUSTOMER"] = "Opname door klant";
    ReadingCategory["AUTOMATIC_ESTIMATE"] = "Automatische schatting";
    ReadingCategory["READING_DERIVED"] = "Opname afgeleid";
    ReadingCategory["MISSING"] = "";
})(ReadingCategory = exports.ReadingCategory || (exports.ReadingCategory = {}));
